import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
};

export default ScrollToTop;
